'use strict';

export default function ($sce) {
  'ngInject';
  return function (videoId) {
    return $sce.trustAsResourceUrl(videoId);
  };
};
